import { render, staticRenderFns } from "./ClaimMonitoring.vue?vue&type=template&id=c6eb86a4"
import script from "./ClaimMonitoring.vue?vue&type=script&lang=js"
export * from "./ClaimMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports